export const StringUtil = {

  htmlEncode(raw: string | null): string | null {
    if (raw === null) {
      return null;
    }

    return raw
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  },

  isValidEmail(email: string | null) : boolean {
    if(!email){
      return false;
    }

    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  },

  supplant(
    template: string | null,
    values: { [ key: string ]: string | null }
  ): string | null {
    if (template === null) {
      return null;
    }

    return template.replace(
      /{([^{}]*)}/g,

      (ignored, propertyName: string) => {
        return values[propertyName] || "";
      }
    );
  },
};
